/*
 * color-swatch
 */
import { cn } from "@timeprox/react/helpers"
import { cva, VariantProps } from "class-variance-authority"
import { HTMLAttributes } from "react"

export type ColorSwatchProps = Omit<
	HTMLAttributes<HTMLDivElement>,
	"children"
> &
	VariantProps<typeof colorSwatchVariants> & {
		color: string | null
	}

export function ColorSwatch({
	color,
	rounded,
	size,
	style = {},
	className,
	...props
}: ColorSwatchProps) {
	return (
		<div
			className={cn(colorSwatchVariants({ rounded, size, className }))}
			style={{ ...style, backgroundColor: color }}
			{...props}
		/>
	)
}

/* Variants */
export const colorSwatchVariants = cva("border", {
	variants: {
		rounded: {
			default: "rounded-md",
			sm: "rounded-xs",
			lg: "rounded-lg",
		},
		size: {
			default: "size-5",
			sm: "size-4",
			lg: "size-6",
		},
	},
	defaultVariants: {
		rounded: "default",
		size: "default",
	},
})
